import get from 'lodash.get';
import { TemplateFieldConfig, TemplateFieldsFormValues } from '../../types';
import { getTimerangeValues, toDateInputValue, toFormFieldValue } from './utils';

export function mapFieldsConfigToTemplateFieldsInitialValues(
  fields: TemplateFieldConfig[],
  source?: Object,
): TemplateFieldsFormValues {
  if (!source) return {};

  return fields.reduce<TemplateFieldsFormValues>((result, field) => {
    const value = get(source, field.fieldName);

    if (field.inputType === 'timerange-picker') {
      const { start, end } = getTimerangeValues(value);
      result[`${field.name}Start`] = start;
      result[`${field.name}End`] = end;
      return result;
    }

    if (field.inputType === 'time-unit-input') {
      result[field.name] = toFormFieldValue(get(source, `${field.fieldName}.time`));
      result[`${field.name}Unit`] = get(source, `${field.fieldName}.unit`);
      return result;
    }

    result[field.name] = field.inputType === 'date-picker'
      ? toDateInputValue(value)
      : toFormFieldValue(value);

    return result;
  }, {});
}
